import { Modal } from 'react-bootstrap';
import ActivatedIcon from 'assets/img/verification/verified.svg';
import Button from 'components/base/Button';

interface Props {
  show: boolean;
  handleSubmit: () => void;
}

const ResetPasswordModal = ({ show, handleSubmit }: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered>
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={ActivatedIcon} width={150} alt="Success Icon" />
        </div>
        <h5 className="text-center fs-6">Password Reset Successful</h5>
        <p className="mt-3 text-center">
          Your password has been successfully reset. Please proceed to sign in
          with your new password. If you encounter any issues, feel free to
          contact our support team for assistance.
        </p>
        <div className="d-flex justify-content-center mb-2">
          <Button variant="outline-primary" onClick={handleSubmit}>
            Back to Sign In
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordModal;
